"use client";

import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { getPublitioPlayerPublic } from "@/actions/publitio-player-public";

interface VSLPlayerProps {
  publitioMediaId: string;
  playerId?: string;
}

export function VSLPlayer({
  publitioMediaId,
  playerId = "11848",
}: VSLPlayerProps) {
  const [playerHtml, setPlayerHtml] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const loadPlayer = async () => {
      try {
        const result = await getPublitioPlayerPublic(publitioMediaId, playerId);

        if (result.success && result.iframe_html) {
          setPlayerHtml(result.iframe_html);
        } else {
          setError(result.error ?? "Error al cargar el video");
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : "Error desconocido");
      } finally {
        setLoading(false);
      }
    };

    void loadPlayer();
  }, [publitioMediaId, playerId]);

  return (
    <div className="vsl-forge-container group relative">
      {/* Industrial frame */}
      <div className="vsl-frame">
        {/* Corner brackets */}
        <div className="corner-bracket top-left" />
        <div className="corner-bracket top-right" />
        <div className="corner-bracket bottom-left" />
        <div className="corner-bracket bottom-right" />

        {/* Video container */}
        <div className="bg-forge-dark relative aspect-video overflow-hidden rounded-md">
          {loading ? (
            // Loading state
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
              <Loader2 className="text-forge-red h-12 w-12 animate-spin" />
              <p className="font-mono text-sm tracking-wider text-white/60 uppercase">
                Cargando video...
              </p>
            </div>
          ) : error ? (
            // Error state
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center">
              <p className="text-lg font-semibold text-red-400">
                Error al cargar el video
              </p>
              <p className="text-sm text-white/60">{error}</p>
            </div>
          ) : (
            // Publitio player
            <div
              className="absolute inset-0 [&_iframe]:h-full [&_iframe]:w-full"
              dangerouslySetInnerHTML={{ __html: playerHtml }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
